import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class GetBuzzwordField extends Http {
  [x: string]: any

  public async getBuzzword(data: NLoginApi.BuzzwordRequestData) {
    return await super.request<NLoginApi.WordcloudResponse>({
      url: '/buzzword/getBuzzword',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }

  public async getBuzzwordPageList(data: NLoginApi.BuzzwordPageListRequestData) {
    return await super.request<NLoginApi.WordcloudResponse>({
      url: '/buzzword/getBuzzwordPageList',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/json'
      },
      data
    })
  }
}

export default GetBuzzwordField
